export enum PLayerTriggeredBy {
  Practitioner,
  Client,
}
